import React from "react";
import { Link } from "react-router-dom";

function Better() {
  const data = [
    {
      id: 1,
      icon: "flaticon-trust",
      name: "Trusted Partners",
    },
    {
      id: 2,
      icon: "flaticon-medical-insurance",
      name: "Protective Insurance",
    },
    {
      id: 3,
      icon: "flaticon-commercial",
      name: "Commercial Insurance",
    },
    {
      id: 4,
      icon: "flaticon-agile",
      name: "Easy Process Systems",
    },
  ];
  return (
    <>
      <section
        className="service-eight"
        style={{
          backgroundImage: "url(assets/images/shapes/service-8-bg-1.png)",
        }}
      >
        <div className="container">
          <div className="sec-title text-center">
            <p className="sec-title__tagline">insurance services</p>

            <h3 className="sec-title__title">
              Take better insurance opportunity
            </h3>
          </div>

          <ul
            className="nav nav-tabs service-eight__tab__btns"
            id="service-eight-tab"
            role="tablist"
          >
            <li role="presentation" className="nav-item ">
              <button
                className="nav-link active"
                id="service-01-tab"
                data-bs-toggle="tab"
                data-bs-target="#service-01"
                type="button"
                role="tab"
                aria-selected="true"
              >
                <i className="flaticon-insurance-1" />
                <span>Life Insurance</span>
              </button>
            </li>
            <li role="presentation" className="nav-item">
              <button
                className="nav-link"
                id="service-02-tab"
                data-bs-toggle="tab"
                data-bs-target="#service-02"
                role="tab"
                type="button"
                aria-selected="true"
              >
                <i className="flaticon-insurance" />
                <span>Business Insurance</span>
              </button>
            </li>
            <li role="presentation" className="nav-item">
              <button
                className="nav-link"
                id="service-03-tab"
                data-bs-toggle="tab"
                data-bs-target="#service-03"
                role="tab"
                type="button"
                aria-selected="true"
              >
                <i className="flaticon-health-insurance" />
                <span>Health Insurance</span>
              </button>
            </li>
            <li role="presentation" className="nav-item">
              <button
                className="nav-link"
                id="service-04-tab"
                data-bs-toggle="tab"
                data-bs-target="#service-04"
                role="tab"
                type="button"
                aria-selected="true"
              >
                <i className="flaticon-insurance-3" />
                <span>House Insurance</span>
              </button>
            </li>
          </ul>

          <div className="tab-content" id="service-eight-tab-content">
            <div
              className="tab-pane fade show active animated fadeInUp"
              id="service-01"
              role="tabpanel"
              aria-labelledby="service-01-tab"
            >
              <div className="row gutter-y-60">
                <div className="col-lg-6">
                  <div className="service-eight__image">
                    <img src="assets/images/resources/service-8-1.jpg" />
                  </div>
                </div>

                <div className="col-lg-6 d-flex">
                  <div className="my-auto">
                    <div className="service-eight__content">
                      <h3 className="service-eight__title">
                        The primary purpose of life insurance is to provide
                        financial benefit to dependants upon premature death of
                        insured person.
                      </h3>

                      <p className="service-eight__text">
                        We denounce with righteous indignation and dislike men
                        beguiled to and demoralized by the charms of pleasure
                        the moment desire is they they cannot foresee the pain
                        and trouble that are bound
                      </p>

                      <ul className="list-unstyled blog-details__list">
                        <li>
                          <i className="far fa-check" />
                          Bake Layers Of Accessibility Testing Into Your Process
                        </li>
                        <li>
                          <i className="far fa-check" />
                          Understanding Easing Functions Animations and
                          Transitions
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade animated fadeInUp"
              id="service-02"
              role="tabpanel"
              aria-labelledby="service-02-tab"
            >
              <div className="row gutter-y-60">
                <div className="col-lg-6">
                  <div className="service-eight__image">
                    <img src="assets/images/resources/service-8-1.jpg" />
                  </div>
                </div>

                <div className="col-lg-6 d-flex">
                  <div className="my-auto">
                    <div className="service-eight__content">
                      <h3 className="service-eight__title">
                        The primary purpose of life insurance is to provide
                        financial benefit to dependants upon premature death of
                        insured person.
                      </h3>

                      <p className="service-eight__text">
                        We denounce with righteous indignation and dislike men
                        beguiled to and demoralized by the charms of pleasure
                        the moment desire is they they cannot foresee the pain
                        and trouble that are bound
                      </p>

                      <ul className="list-unstyled blog-details__list">
                        <li>
                          <i className="far fa-check" />
                          Bake Layers Of Accessibility Testing Into Your Process
                        </li>
                        <li>
                          <i className="far fa-check" />
                          Understanding Easing Functions Animations and
                          Transitions
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade animated fadeInUp"
              id="service-03"
              role="tabpanel"
              aria-labelledby="service-03-tab"
            >
              <div className="row gutter-y-60">
                <div className="col-lg-6">
                  <div className="service-eight__image">
                    <img src="assets/images/resources/service-8-1.jpg" />
                  </div>
                </div>

                <div className="col-lg-6 d-flex">
                  <div className="my-auto">
                    <div className="service-eight__content">
                      <h3 className="service-eight__title">
                        The primary purpose of life insurance is to provide
                        financial benefit to dependants upon premature death of
                        insured person.
                      </h3>

                      <p className="service-eight__text">
                        We denounce with righteous indignation and dislike men
                        beguiled to and demoralized by the charms of pleasure
                        the moment desire is they they cannot foresee the pain
                        and trouble that are bound
                      </p>

                      <ul className="list-unstyled blog-details__list">
                        <li>
                          <i className="far fa-check" />
                          Bake Layers Of Accessibility Testing Into Your Process
                        </li>
                        <li>
                          <i className="far fa-check" />
                          Understanding Easing Functions Animations and
                          Transitions
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade animated fadeInUp"
              id="service-04"
              role="tabpanel"
              aria-labelledby="service-04-tab"
            >
              <div className="row gutter-y-60">
                <div className="col-lg-6">
                  <div className="service-eight__image">
                    <img src="assets/images/resources/service-8-1.jpg" />
                  </div>
                </div>

                <div className="col-lg-6 d-flex">
                  <div className="my-auto">
                    <div className="service-eight__content">
                      <h3 className="service-eight__title">
                        The primary purpose of life insurance is to provide
                        financial benefit to dependants upon premature death of
                        insured person.
                      </h3>

                      <p className="service-eight__text">
                        We denounce with righteous indignation and dislike men
                        beguiled to and demoralized by the charms of pleasure
                        the moment desire is they they cannot foresee the pain
                        and trouble that are bound
                      </p>

                      <ul className="list-unstyled blog-details__list">
                        <li>
                          <i className="far fa-check" />
                          Bake Layers Of Accessibility Testing Into Your Process
                        </li>
                        <li>
                          <i className="far fa-check" />
                          Understanding Easing Functions Animations and
                          Transitions
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-eight">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 d-flex">
              <div className="my-auto">
                <div className="sec-title text-start">
                  <p className="sec-title__tagline">Why choose us</p>

                  <h3 className="sec-title__title">
                    Find Best Insurance Agent or Need Consultations?
                  </h3>
                </div>

                <div className="faq-three__right">
                  {data.map((item) => (
                    <div className="faq-three__box" key={item.id}>
                      <div className="faq-three__box__icon">
                        <i className={item.icon} />
                      </div>

                      <h3 className="faq-three__box__title">
                        <Link to="/insurancesdetails">{item.name}</Link>
                      </h3>

                      <Link
                        to="/insurancesdetails"
                        className="faq-three__box__link"
                      >
                        <i className="far fa-long-arrow-right" />
                      </Link>

                      <div className="faq-three__box__hover">
                        <div className="faq-three__box__hover__icon">
                          <i className={item.icon} />
                        </div>

                        <h3 className="faq-three__box__hover__title">
                          <Link to="/insurancesdetails">{item.name}</Link>
                        </h3>

                        <div className="faq-three__box__hover__text">
                          Take a trivial example which of ever undertakes
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="about-eight__image">
                <img src="assets/images/resources/about-8-1.jpg" />
                <div className="about-five__image__caption">
                  <h3 className="about-five__image__caption__title">
                    2 Years Of Experience in Insurance Services
                  </h3>

                  <p className="about-five__image__caption__text">
                    CEO &amp; Founder
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Better;
